export const APP_VERSION="v0.2.0_rc169_cx | 9d237df8b51ff01deff81f464f5d88ce56afe162"
